import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from '../../field.interface';
@Component({
    selector: 'app-textarea',
    templateUrl: './textarea.component.html',
    styles: [],
    standalone: false
})
export class TextAreaComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;

  constructor() { }

  ngOnInit() { }
}
